@if (isVisible$ | async) {
  <nav data-zid="navigation" class="navigation navigation-header" [class.open]="isMobileNavigationVisible" (mouseleave)="closeDropdowns()">
    <div class="inner">
      <div class="navigation-hamburger-wrapper">
        <div class="navigation-hamburger navigation-hamburger--spring" (click)="toggleMobileNavigation(); isMobileSearchVisible = false">
          <div class="navigation-hamburger-box">
            <div class="navigation-hamburger-inner"></div>
          </div>
        </div>
      </div>
      <div class="logo-container">
        <a
          (click)="closeDropdowns()"
          [routerLink]="(isLoggedIn$ | async) ? commonRoutes.postlogin.member_home : commonRoutes.prelogin.home"
        >
          <div class="d-block d-lg-none">
            <img src="assets/img/svgs/logo-nav-mobile.svg" alt="logo" />
          </div>
          <div class="d-none d-lg-block">
            <img src="assets/img/svgs/logo-nav.svg" alt="logo" />
          </div>
        </a>
      </div>
      @if (isLoggedIn$ | async) {
        <div class="navigation-mobile-search-icon d-lg-none" (click)="toggleMobileSearch(); isMobileNavigationVisible = false">
          <svg class="icon icon-18 mirror"><use xlink:href="/assets/img/svgs/svgset.svg#search" /></svg>
        </div>
      }
      <div class="navigation-items">
        @if (isCustomer$ | async) {
          <div
            class="navigation-item"
            (click)="closeMobileNavigation()"
            (mouseenter)="closePrivateLinks(); openDepotDropdownLinks()"
            [routerLink]="commonRoutes.postlogin.member_home"
            routerLinkActive="navigation-submenu-item--active"
            data-zid="navigation-depot"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            {{ 'header.home' | transloco }}
            <web-design-system-icon name="chevron-2" size="small" />
            <div class="item-highlight" routerLinkActive="item-active"></div>
          </div>
          <div
            class="dropdown"
            data-zid="private-links-dropdown"
            (mouseleave)="closeDepotDropdownLinks()"
            [class.item-active]="isDepotDropdownVisible"
          >
            <div
              class="navigation-item no-select"
              (click)="closeMobileNavigation()"
              [routerLink]="commonRoutes.postlogin.orders"
              routerLinkActive="navigation-submenu-item--active"
              data-zid="navigation-orders"
            >
              {{ 'header.my-orders' | transloco }}
              <div class="item-highlight" routerLinkActive="item-active"></div>
            </div>
            @if (isCustomer$ | async) {
              <div
                class="navigation-item no-select"
                (click)="closeMobileNavigation()"
                [routerLink]="commonRoutes.postlogin.stats"
                routerLinkActive="navigation-submenu-item--active"
                data-zid="navigation-statistics"
              >
                {{ 'header.stats' | transloco }}
                <div class="item-highlight" routerLinkActive="item-active"></div>
              </div>
              @if (lombardEnabled$ | async) {
                <div
                  class="navigation-item no-select"
                  (click)="closeMobileNavigation()"
                  [routerLink]="commonRoutes.postlogin.lombard"
                  routerLinkActive="navigation-submenu-item--active"
                  data-zid="navigation-lombard"
                >
                  {{ 'header.lombard' | transloco }}
                  <div class="item-highlight" routerLinkActive="item-active"></div>
                </div>
              }
            }
          </div>

          <ng-container *ngTemplateOutlet="item; context: { label: 'watchlist', link: commonRoutes.postlogin.watchlist }" />
          <ng-container *ngTemplateOutlet="item; context: { label: 'savings-plans', link: commonRoutes.postlogin.savings_plans }" />
          <ng-container *ngTemplateOutlet="item; context: { label: 'trading', link: commonRoutes.postlogin.trading }" />
          <ng-container *ngTemplateOutlet="item; context: { label: 'crypto', link: commonRoutes.postlogin.crypto }" />

          <div>
            <div
              class="navigation-item"
              (click)="closeMobileNavigation()"
              (mouseenter)="closePrivateLinks(); openMoreDropdownLinks()"
              data-zid="navigation-more"
            >
              {{ 'header.more' | transloco }}
              <web-design-system-icon name="chevron-2" size="small" />
            </div>
            <div
              class="dropdown"
              data-zid="more-links-dropdown"
              (mouseleave)="closeMoreDropdownLinks()"
              [class.item-active]="isMoreDropdownVisible"
            >
              <div
                class="navigation-item no-select"
                (click)="closeMobileNavigation()"
                [routerLink]="commonRoutes.postlogin.accountoverview"
                routerLinkActive="navigation-submenu-item--active"
                [attr.data-zid]="'navigation-account'"
              >
                {{ 'header.account' | transloco }}
                <div class="item-highlight" routerLinkActive="item-active"></div>
              </div>
              <div class="navigation-item no-select" (click)="openExternal('https://www.finanzen.net/zero/zinsen')">
                {{ 'header.interests' | transloco }}
                <div class="item-highlight" routerLinkActive="item-active"></div>
              </div>
              <div
                class="navigation-item no-select"
                (click)="closeMobileNavigation()"
                [routerLink]="commonRoutes.postlogin.wincustomer"
                routerLinkActive="navigation-submenu-item--active"
                [attr.data-zid]="'navigation-recommend'"
              >
                {{ 'header.recommend' | transloco }}
                <div class="item-highlight" routerLinkActive="item-active"></div>
              </div>
              <div
                class="navigation-item no-select"
                (click)="closeMobileNavigation()"
                [routerLink]="commonRoutes.postlogin.portfolioTransfer"
                routerLinkActive="navigation-submenu-item--active"
                [attr.data-zid]="'navigation-portfolio-transfer'"
              >
                {{ 'header.portfolio-transfer' | transloco }}
                <div class="item-highlight" routerLinkActive="item-active"></div>
              </div>
            </div>
          </div>

          <div
            class="navigation-item no-select hidden-lg hidden-xl"
            (click)="closeMobileNavigation()"
            (mouseenter)="closeDropdowns()"
            [routerLink]="commonRoutes.prelogin.tradeableproducts"
            routerLinkActive="navigation-submenu-item--active"
          >
            {{ 'header.tradable-products' | transloco }}
            <div class="item-highlight" routerLinkActive="item-active"></div>
          </div>
          <div
            class="navigation-item mr-0 hidden-xs hidden-sm hidden-md navigation-asset-search"
            [ngClass]="{ 'd-md-none d-lg-none d-xl-block': isPotentialCustomer$ | async }"
            (mouseenter)="closeDropdowns()"
          >
            <web-components-asset-search type="header" />
          </div>

          <hr class="navigation-item-seperator" />
          @if (isCustomer$ | async) {
            <div class="navigation-item navigation-item-mobile">
              <a
                [routerLink]="commonRoutes.postlogin.posteingang"
                (click)="closeMobileNavigation()"
                routerLinkActive="navigation-submenu-list-item--active"
              >
                {{ 'header.inbox' | transloco }}
                @if (unreadDocs$ | async; as unreadDocs) {
                  <span class="badge badge-pill badge-danger">{{ unreadDocs }}</span>
                }
              </a>
            </div>
            <div class="navigation-item navigation-item-mobile">
              <a
                [routerLink]="commonRoutes.postlogin.tickets"
                (click)="closeMobileNavigation()"
                routerLinkActive="navigation-submenu-list-item--active"
              >
                {{ 'header.tickets' | transloco }}
                @if (unreadTickets$ | async; as unreadTickets) {
                  <span class="badge badge-pill badge-danger">{{ unreadTickets }}</span>
                }
              </a>
            </div>
            <div class="navigation-item navigation-item-mobile">
              <a [routerLink]="commonRoutes.postlogin.verwaltung" (click)="closeMobileNavigation()">
                {{ 'header.administration' | transloco }}
              </a>
            </div>
          }
        }
        @if (isLoggedIn$ | async) {
          <div class="navigation-item navigation-item-mobile d-flex hidden-lg hidden-xl cursor-pointer" (click)="logOut()">
            {{ 'header.logout' | transloco }}
          </div>
        }
      </div>

      <div class="navigation-action-bar">
        @if ((isLoggedIn$ | async) && (isPotentialCustomer$ | async)) {
          <div class="action-bar-item zero-text p-base-med" (click)="logOut()">
            {{ 'header.logout' | transloco }}
          </div>
        }
        @if ((isLoggedIn$ | async) && (isCustomer$ | async)) {
          <div class="action-bar-item">
            <div class="profile-icon-wrapper">
              <div
                class="profile-icon profile-color"
                (mouseenter)="openOrderDropdownLinks()"
                data-zid="navigation-buy"
                (click)="navigateToBuy()"
                title="Kaufen"
              >
                <div class="profile-icon add-color">
                  <svg class="icon">
                    <use xlink:href="/assets/img/svgs/svgset.svg#addcard" />
                  </svg>
                </div>
              </div>
            </div>
            <div
              class="private-links"
              data-zid="order-links-dropdown"
              [class.open]="isOrderLinksVisible"
              (mouseleave)="closeOrderDropdownLinks()"
            >
              <div
                class="navigation-item"
                [routerLink]="commonRoutes.postlogin.buyAndSell"
                (click)="closeMobileNavigation()"
                data-zid="order-link-buyAndSell"
              >
                <span class="private-links-link">Einzelorder</span>
                <div class="highlight" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"></div>
              </div>
              <div
                class="navigation-item"
                [routerLink]="commonRoutes.postlogin.multiOrder"
                (click)="closeMobileNavigation()"
                data-zid="order-link-multiOrder"
              >
                <span class="private-links-link">Multi-Order</span>
                <div class="highlight" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"></div>
              </div>
            </div>
          </div>
          <div class="action-bar-item" data-zid="action-bar">
            <div class="profile-icon-wrapper" [class.open]="isPrivateLinksVisible">
              <div
                class="profile-icon profile-color"
                (mouseenter)="openPrivateLinks()"
                (click)="isPrivateLinksVisible = !isPrivateLinksVisible"
              >
                <svg class="icon">
                  <use xlink:href="/assets/img/svgs/svgset.svg#header-profile-icon" />
                </svg>
                @if (unreadTotal$ | async; as total) {
                  <span class="badge badge-pill badge-danger align-self-start">{{ total }}</span>
                }
              </div>
            </div>

            <div
              class="private-links"
              data-zid="private-links-dropdown"
              [class.open]="isPrivateLinksVisible"
              (mouseleave)="closePrivateLinks()"
            >
              <div
                class="navigation-item"
                [routerLink]="commonRoutes.postlogin.posteingang"
                (click)="closeMobileNavigation()"
                data-zid="private-link-inbox"
              >
                <span class="private-links-link">{{ 'header.inbox' | transloco }}</span>
                @if (unreadDocs$ | async; as unreadDocs) {
                  <span class="badge badge-pill badge-danger">{{ unreadDocs }}</span>
                }

                <div class="highlight" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"></div>
              </div>

              <div
                class="navigation-item"
                [routerLink]="commonRoutes.postlogin.tickets"
                (click)="closeMobileNavigation()"
                data-zid="private-link-tickets"
              >
                <span class="private-links-link">{{ 'header.tickets' | transloco }}</span>
                @if (unreadTickets$ | async; as unreadTickets) {
                  <span class="badge badge-pill badge-danger">{{ unreadTickets }}</span>
                }
                <div class="highlight" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"></div>
              </div>
              <div
                class="navigation-item"
                data-zid="private-link-controls"
                [routerLink]="commonRoutes.postlogin.verwaltung"
                (click)="closeMobileNavigation()"
              >
                <span class="private-links-link">{{ 'header.administration' | transloco }}</span>
                <div class="highlight" routerLinkActive="active"></div>
              </div>
              <div class="navigation-item" data-zid="private-link-logout" (click)="logOut()">
                <span class="private-links-link mr-2">{{ 'header.logout' | transloco }}</span>
                <div class="highlight" routerLinkActive="active"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </nav>

  <ng-template #item let-link="link" let-label="label" let-isNew="isNew">
    <div
      class="navigation-item no-select"
      (click)="closeMobileNavigation()"
      (mouseenter)="closeDropdowns()"
      [routerLink]="link"
      routerLinkActive="navigation-submenu-item--active"
      [attr.data-zid]="'navigation-' + label"
    >
      {{ 'header.' + label | transloco }}
      <div class="item-highlight" routerLinkActive="item-active"></div>
      @if (isNew) {
        <web-design-system-pill type="new">{{ 'header.new-badge' | transloco }}</web-design-system-pill>
      }
    </div>
  </ng-template>
}

@if (isMobileSearchVisible) {
  <div class="mobile-search d-lg-none">
    <web-components-asset-search type="header" (silentAssetSelected)="isMobileSearchVisible = false" />
  </div>
}
